module.exports = __webpack_public_path__ + "img/quotes-2.4e6ef3fc.png";